<script setup lang="ts">
import { useAuthStore } from '~/stores/auth'

const authStore = useAuthStore()
const { user } = storeToRefs(authStore)
</script>

<template>
    <div v-if="user || $route.meta.authRequired == false">
        <slot></slot>
    </div>
</template>
